import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import SignupPage from "@/pages/auth/signup/page";
import LoginPage from "@/pages/auth/login/page";
import ContractPage from "@/pages/auth/contract/page";
import PaymentSetupPage from "@/pages/auth/payment-setup/page";
import AvailableLeadsPage from "@/pages/dashboard/available-leads/page";
import PurchasedLeadsPage from "@/pages/dashboard/purchased-leads/page";
import BillingPage from "@/pages/dashboard/billing/page";
import SettingsPage from "@/pages/dashboard/settings/page";
import DashboardContractPage from "@/pages/dashboard/contract/page";
import AdminPage from "@/pages/admin/page";
import PricingPage from "@/pages/pricing/page";
import BlogPage from "@/pages/blog/page";
import ArticlePage from "@/pages/blog/article/page";
import ContactPage from "@/pages/contact/page";
import ForgotPasswordPage from "@/pages/auth/forgot-password/page";
import ResetPasswordPage from "@/pages/auth/reset-password/page";
import PrivacyPolicyPage from "@/pages/legal/privacy/page";
import TermsOfServicePage from "@/pages/legal/terms/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/pricing", element: <PricingPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:slug", element: <ArticlePage /> },
  { path: "/contact", element: <ContactPage /> },
  { path: "/signup", element: <SignupPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  { path: "/contract", element: <ContractPage /> },
  { path: "/payment-setup", element: <PaymentSetupPage /> },
  { path: "/dashboard", element: <AvailableLeadsPage /> },
  { path: "/dashboard/purchased", element: <PurchasedLeadsPage /> },
  { path: "/dashboard/billing", element: <BillingPage /> },
  { path: "/dashboard/settings", element: <SettingsPage /> },
  { path: "/dashboard/contract", element: <DashboardContractPage /> },
  { path: "/admin", element: <AdminPage /> },
  { path: "/admin/leads", element: <AdminPage /> },
  { path: "/admin/installers", element: <AdminPage /> },
  { path: "/admin/purchases", element: <AdminPage /> },
  { path: "/privacy-policy", element: <PrivacyPolicyPage /> },
  { path: "/terms-of-service", element: <TermsOfServicePage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
